import React, { useEffect, useState } from 'react';

import EventIcon from '@mui/icons-material/Event';
import { Grid, Link, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { Box } from '@mui/system';
import dayjs from 'dayjs';
import { sortBy } from 'lodash';

import { StyledChip } from '../../common_components/styled';

import { TokenInfo } from './TokenInfo';

export const TDHeader = (props) => {
  const { token_name, ticker, ecosystems, categories, launch_sites } = props;
  const [isOngoing, setIsOngoing] = useState(false);

  useEffect(() => {
    const sortedDates = sortBy(launch_sites, (item) => item.launch_start_date).reverse();
    sortedDates.map(({ launch_end_date, launch_start_date }) => {
      console.log(dayjs(launch_start_date).utc('z'));
      const isLive =
        dayjs().utc().isAfter(dayjs(launch_start_date).utc('z')) &&
        (!dayjs(launch_end_date).isValid() || dayjs().isBefore(dayjs(launch_end_date).utc('z')));

      if (isLive) {
        setIsOngoing(true);
      }
    });
  }, []);
  const getSaleDuration = (startDate, endDate) => {
    return (
      <Stack direction="row" sx={{ mt: 1 }}>
        <Tooltip title="Event">
          <EventIcon sx={{ fontSize: 19, color: '#58667e' }} />
        </Tooltip>
        <Typography variant="body2" gutterBottom component="div" color={'#58667e'}>
          {`${
            dayjs(startDate).utc().isValid() ? dayjs(startDate).format('DD MMM, HH:mm') : 'TBA'
          } - ${
            dayjs(endDate).utc().isValid() ? dayjs(endDate).format('DD MMM, HH:mm') : 'TBA'
          } UTC`}
        </Typography>
      </Stack>
    );
  };
  const getEcosystems = () => {
    const hiddenData = ecosystems?.length > 3 ? ecosystems?.slice(3) : [];
    const dataToBeShown = ecosystems?.slice(0, 3);

    if (hiddenData.length > 0) {
      return (
        <Stack direction="row" spacing={1}>
          <StyledChip label={'EcoSystem :'} fontColor={'#8dc647'} variant="outlined" />

          {dataToBeShown?.map((data, index) => (
            <StyledChip label={data.ecosys_name} bgcolor="#8dc647" key={index} variant="outlined" />
          ))}
          <Tooltip title={hiddenData?.map((item) => item.ecosys_name).join('\n')}>
            <StyledChip label={`+${hiddenData.length}`} fontColor="#8dc647" variant="outlined" />
          </Tooltip>
        </Stack>
      );
    } else {
      return (
        <>
          <StyledChip label={'EcoSystem :'} fontColor={'#8dc647'} variant="outlined" />

          {dataToBeShown?.map((data, index) => (
            <StyledChip bgcolor="#8dc647" label={data.ecosys_name} key={index} variant="outlined" />
          ))}
        </>
      );
    }
  };

  const getCategories = () => {
    const hiddenData = categories?.length > 3 ? categories?.slice(3) : [];
    const dataToBeShown = categories?.slice(0, 3);

    if (hiddenData.length > 0) {
      return (
        <>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            <StyledChip label={'Category :'} fontColor="purple" variant="outlined" />

            {dataToBeShown?.map((data, index) => (
              <StyledChip
                bgcolor={'purple'}
                label={data.category_name}
                key={index}
                variant="outlined"
              />
            ))}
          </Stack>
          <Tooltip title={hiddenData.map((item) => item.category_name).join('\n')}>
            <StyledChip label={`+${hiddenData.length}`} variant="outlined" fontColor={'#8dc647'} />
          </Tooltip>
        </>
      );
    } else {
      return (
        <>
          <StyledChip label={'Category :'} fontColor="purple" variant="outlined" />
          {dataToBeShown?.map((data, index) => (
            <StyledChip
              label={data.category_name}
              bgcolor={'purple'}
              key={index}
              variant="outlined"
            />
          ))}
        </>
      );
    }
  };
  return (
    <Paper
      sx={{
        borderRadius: 10,
        boxShadow: '0 6px 12px 0 rgba(34, 35, 58, 0.2)',
        p: { md: 2, sm: 1, xs: 1 }
      }}
      elevation={9}>
      <Grid container spacing={1}>
        <Grid item xs={12} md={6}>
          <Stack direction="row" sx={{ display: 'flex', alignItems: 'center' }}>
            {props.logo_url && (
              <img
                src={props.logo_url}
                height="40px"
                style={{ borderRadius: '50%', paddingRight: '4px' }}
              />
            )}
            <Stack direction="row">
              <Typography
                variant="h6"
                noWrap
                component="div"
                sx={{
                  marginLeft: '10px'
                }}>
                {`${token_name}(${ticker})`}
              </Typography>
              {isOngoing && (
                <StyledChip
                  label={`Live`}
                  bgcolor="#00a152"
                  sx={{ mb: -2, ml: 1, height: 15, p: 0 }}
                />
              )}
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
            {getEcosystems()}
          </Stack>
          <Stack direction="row" spacing={1} sx={{ pt: 1 }}>
            {getCategories()}
          </Stack>
          <Box>
            {launch_sites?.length > 0 ? (
              <>
                <Typography variant="subtitle3" gutterBottom sx={{ mr: 2 }}>
                  {'Places To Buy:'}
                </Typography>

                {sortBy(launch_sites, (item) => item.launch_start_date)?.map((data, index) => (
                  <Stack direction="row" key={index}>
                    <StyledChip
                      label={`${data.site_name}`}
                      fontColor="black"
                      bgColor="#f3f4f6"
                      sx={{ m: 1 }}
                      key={index}
                      size="small"
                      component={Link}
                      target="_blank"
                      href={data.launch_site}
                    />
                    {getSaleDuration(data.launch_start_date, data.launch_end_date)}{' '}
                  </Stack>
                ))}
              </>
            ) : null}
          </Box>
        </Grid>
        {/* <Grid
          item
          xs={12}
          md={6}
          sx={{ display: 'flex', justifyContent: { md: 'center' }, width: { md: 50 } }}>
          {!isMobile && <CountDownTimer date={dayjs("12/12/2022")} />}{' '}
        </Grid> */}
        <Grid item xs={12} md={3} />
        <Grid item xs={12} md={3}>
          <TokenInfo {...props} />
        </Grid>
      </Grid>
    </Paper>
  );
};
